import { ScrollTrigger } from 'gsap/ScrollTrigger.js'
import { sliderDotsAnimation } from '../utilities/slider-dots-animation'

let xs = 0
let sm = 600
let md = 800
let lg = 1200
let xl = 1400
let xxl = 2000
let screenWidth = window.innerWidth

let quotes_slider = $('.quotes-slider-init')
if (quotes_slider.length) {
    let quotes_slider_slick = quotes_slider.slick({
        infinite: true,
        dots: false,
        swipe: false,
        touchMove: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        useTransform: false,
        speed: 400,
        pauseOnFocus: false,
        pauseOnHover: false,
        waitForAnimate: false,
        prevArrow: $('.prev'),
        nextArrow: $('.next'),
        fade: true,
        cssEase: 'linear',
        responsive: [
            {
                breakpoint: md,
                settings: {
                    dots:true,
                }
            },
            {
                breakpoint: sm,
                settings: {
                    dots:true,
                    fade: false,
                    arrows: true,
                    centerMode: true,
                    centerPadding: '5vw',
                    swipe: true,
                    touchMove: true,
                    waitForAnimate: true,
                }
            },
        ]
    })

    quotes_slider_slick.on('beforeChange',
        function (event, slick, currentSlide, nextSlide) {
            let dots = $(this).closest('section').find('.js-dots')
            sliderDotsAnimation(dots, currentSlide, nextSlide)
        })

    let animateQuotesSlide,
        animateQuotesSwitchTime = 400,
        animateQuotesAnimating = false,
        animateQuotesFrame = 0

    let quotesAnimateLine = quotes_slider.find('.line-filled')
    let animateQuotesFrameCssCoef = 0.25
    let animateQuotesFrameCss = 0

    function reset () {
        quotesAnimateLine.css('width', 0)
        animateQuotesFrameCss = 0
        animateQuotesAnimating = false
        animateQuotesFrame = 0
    }

    function changeQuotesSlide () {
        animateQuotesSlide = requestAnimationFrame(changeQuotesSlide)

        if (!animateQuotesAnimating) {
            animateQuotesFrame += 1
        }
        animateQuotesFrameCss += animateQuotesFrameCssCoef
        quotesAnimateLine.css('width', animateQuotesFrameCss + '%')

        if (animateQuotesFrame > animateQuotesSwitchTime &&
            !animateQuotesAnimating) {
            animateQuotesAnimating = true

            quotes_slider.slick('next')

            //reset
            reset()

        }
    }

    $('.js-prev, .js-next').on('click', function () {
        //reset
        reset()

    })

    if (screenWidth > sm) {
        //changeQuotesSlide()

        function runQuotesAnimation()
        {
            changeQuotesSlide()
        }

        function endQuotesAnimation()
        {
            window.cancelAnimationFrame(animateQuotesSlide)
        }

        ScrollTrigger.create({
            trigger: '#block-quotes-trigger',
            start: 'top center',
            end: 'bottom center',
            onEnter: runQuotesAnimation,
            onEnterBack: runQuotesAnimation,
            onLeave: endQuotesAnimation,
            onLeaveBack: endQuotesAnimation,
            //markers: true
        })


    }

}

